export function getProductCodeFromPvc(pvc: string) {
	// PVC = productcode_attribute~aspectratio
	const dashPos = pvc.indexOf("_");
	const tildePos = pvc.indexOf("~");
	if (dashPos < 0 && tildePos < 0) return pvc;

	return pvc.substring(0, dashPos > 0 ? dashPos : tildePos);
}

export function getAspectRatioFromPvc(pvc: string) {
	// PVC = productcode_attribute~aspectratio
	const tildePos = pvc.indexOf("~");
	if (tildePos < 0) return "";

	return pvc.substring(tildePos + 1);
}

const Orientation = Object.freeze({
	Undefined: "Undefined",
	Horizontal: "Horizontal",
	Vertical: "Vertical",
	Square: "Square",
});

export function getOrientationFromPvc(pvc: string) {
	const aspectRatio = getAspectRatioFromPvc(pvc);

	return getOrientationFromAspectRatio(aspectRatio);
}
export function getOrientationFromAspectRatio(aspectRatio: string) {
	if (!aspectRatio) return Orientation.Undefined;

	const parts = aspectRatio.split("x");
	if (parts.length !== 2) return Orientation.Undefined;

	const width = parseInt(parts[0], 10);
	const height = parseInt(parts[1], 10);

	if (isNaN(width) || isNaN(height)) return Orientation.Undefined;

	if (width > height) return Orientation.Horizontal;
	else if (width < height) return Orientation.Vertical;
	else return Orientation.Square;
}
